import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 17 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.336 8.667a4 4 0 0 0-3.72 2.712l-.196.578a.896.896 0 0 0 .453 1.092 9 9 0 0 0 3.433.907 4.64 4.64 0 0 1-.806-2.623c0-.99.309-1.91.836-2.666m3.164-4a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "##101820",
      fillRule: "evenodd",
      d: "M11.167 14.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667m0-5.334c.368 0 .666.299.666.667v.667h.667a.667.667 0 1 1 0 1.333h-.667v.667a.667.667 0 0 1-1.333 0V12h-.667a.667.667 0 0 1 0-1.333h.667V10c0-.368.298-.667.666-.667",
      clipRule: "evenodd"
    }
  )
);
var SvgUserAddFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var UserAddFilled_default = SvgUserAddFilled;

export { UserAddFilled_default as default };
